/** @jsxImportSource preact */
import { CARD_STYLES } from "../form/card-styles";
import { FORM_STYLES, formVars } from "../form/form-styles";
import { ICON_TILE_STYLES, IconTile } from "../contact/card-parts";
import type { WidgetTokens } from "../theme";
import {
  CardActions,
  CardIcon,
  type WidgetCardAction,
  type WidgetCardIcon,
} from "./card-actions";

export interface ActionCardProps {
  /** 一到三个按钮，从上到下排；第一个没给 variant 的是墨黑主答案。 */
  actions: WidgetCardAction[];
  description?: string;
  /** 给了图标就在标题前画一个井色图标圆，不给就是纯文字卡头。 */
  icon?: WidgetCardIcon;
  /** 读屏用的名字，默认取标题。 */
  label?: string;
  title: string;
  tokens: WidgetTokens;
}

export const ACTION_CARD_STYLES = `${ICON_TILE_STYLES}
.gn-action-head { display:flex; flex-direction:column; gap:4px; min-width:0; }
.gn-action-note { display:flex; align-items:flex-start; gap:10px; padding:2px 4px 0; }
.gn-action-note-text { display:flex; flex-direction:column; justify-content:center; gap:2px; min-width:0; min-height:36px; }
.gn-action-desc { font-size:13px; line-height:1.4; color:var(--gn-form-quiet); }
.gn-action-note-text > .gn-action-desc { font-size:12px; }
.gn-action-body { display:flex; flex-direction:column; gap:8px; }
`;

/**
 * 入口卡：一句话说明加几个整宽胶囊按钮，如「Find your orders」的店铺登录，
 * 或联系店铺的建议。
 */
export function ActionCard({
  actions,
  description,
  icon,
  label,
  title,
  tokens: t,
}: ActionCardProps) {
  return (
    <div
      aria-label={label ?? title}
      class="gn-card"
      role="group"
      style={formVars(t)}
    >
      <style>{`${FORM_STYLES}${CARD_STYLES}${ACTION_CARD_STYLES}`}</style>
      {icon ? (
        <div class="gn-action-note">
          <IconTile tone="soft">
            <CardIcon icon={icon} size={18} />
          </IconTile>
          <div class="gn-action-note-text">
            <h3 class="gn-card-title">{title}</h3>
            {description && <div class="gn-action-desc">{description}</div>}
          </div>
        </div>
      ) : (
        <div class="gn-card-head">
          <div class="gn-action-head">
            <h3 class="gn-card-title">{title}</h3>
            {description && <div class="gn-action-desc">{description}</div>}
          </div>
        </div>
      )}
      <div class="gn-action-body">
        <CardActions actions={actions} tokens={t} />
      </div>
    </div>
  );
}
